import React, { useState } from 'react';

import { GradFairGradProgramLinksBlockData } from 'api/cms';
import { PublicPage } from 'api/website';
import { getIsContentFullWidthLayout } from 'cms/helpers';
import { Box } from 'components/Box';
import { Divider } from 'components/Divider';
import { Link } from 'components/Link';
import { H2, HeadingSmall } from 'components/Text';
import { colors, gutterWidth } from 'theme';

import { GradFairGradProgramLinksBlockToggleButton } from './GradFairGradProgramLinksBlockToggleButton';

const LIMIT = 7;

type Props = {
  content: PublicPage;
  data: GradFairGradProgramLinksBlockData;
};

export function GradFairGradProgramLinksBlock({
  content,
  data: { orgs },
}: Props) {
  const fullWidthLayout = getIsContentFullWidthLayout({ content });
  const showButton = orgs.length > LIMIT;
  const [showAll, setShowAll] = useState(!showButton);

  const toggle = () => {
    setShowAll((prev) => !prev);
  };

  return (
    <Box
      data-qa-id="cms-grad-fair-grad-program-links"
      textAlign={fullWidthLayout ? 'center' : undefined}
    >
      <H2>{getText('Participating Programs')}</H2>

      <Box mt={[36, null, null, 48]} mb={-12}>
        {orgs
          .slice(0, showAll ? undefined : LIMIT)
          .map(({ id, name, program, url }) => (
            <Box
              key={id}
              py={12}
              width={fullWidthLayout ? [1, 1, 3 / 4] : undefined}
              mx="auto"
              data-qa-id="program-link"
            >
              {program && (
                <HeadingSmall color={colors.battleshipGrey} mb="8px">
                  {program && program.schoolName}
                </HeadingSmall>
              )}

              <Link
                href={
                  program ? program.url[CURRENT_LOCALE] : url[CURRENT_LOCALE]
                }
              >
                {program ? program.name : name}
              </Link>
            </Box>
          ))}
      </Box>

      {showButton &&
        (fullWidthLayout ? (
          <Box position="relative">
            <Box width={[1, 3 / 4, 1 / 2]} mx="auto">
              <Divider mt={gutterWidth * 1.5} mb={18} dashed />
            </Box>
            <Box
              position="absolute"
              left="50%"
              top="50%"
              transform="translate(-50%, -50%)"
            >
              <Box px={[12, null, 24]} bg="white">
                <GradFairGradProgramLinksBlockToggleButton
                  showAll={showAll}
                  toggle={toggle}
                />
              </Box>
            </Box>
          </Box>
        ) : (
          <Box mt={gutterWidth}>
            <GradFairGradProgramLinksBlockToggleButton
              showAll={showAll}
              toggle={toggle}
            />
          </Box>
        ))}
    </Box>
  );
}
